import { faVideo } from '@fortawesome/pro-regular-svg-icons/faVideo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './AddVideo.module.scss';

interface AddVideoProps {
    className?: string;
    onClick?: () => void;
}

export const AddVideo: FunctionComponent<AddVideoProps> = props => {
    return (
        <div
            className={clsx(styles.container, props.className)}
            onClick={props.onClick}
        >
            <FontAwesomeIcon
                icon={faVideo}
                color="#D3D3D3"
                className={styles.icon}
            />
            <span className={styles.text}>+ Add Video</span>
        </div>
    );
};

export default AddVideo;
